import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useClaimContext } from 'contexts/ClaimContext';
import BaseTable from 'components/new_ui/Table';
import confirmAlert from 'components/new_ui/Alerts/confirm';
import Alert from 'components/new_ui/Alerts/alert';
import columns from './Table/columns';
import NoData from './Table/NoData';

import EditModal from './Edit/Index';

export default function Table({ isPossibleAddClaim }) {
  const { state } = useClaimContext();
  const { dispatch, actions } = useClaimContext();

  const [selectedClaim, setSelectedClaim] = useState(null);

  const rowActions = [
    {
      type: 'EXPAND',
    },
    {
      title: 'Edit',
      type: 'CUSTOM',
      iconClass: 'edit-icon',
      onClick: (row) => { setSelectedClaim(row); },
      showCondition: (row) => row.attributes.possible_change,
    },
    {
      title: 'Delete',
      type: 'CUSTOM',
      iconClass: 'trash-icon',
      showCondition: (row) => row.attributes.possible_change,
      onClick: (row) => {
        confirmAlert({
          title: 'Delete',
          text: 'Do you want to delete this claim?',
          confirmButtonText: 'Delete',
        }, () => {
          actions.removeClaim(dispatch, row, () => {
            Alert({
              title: 'Claim Deleted!',
              text: "Our claim's specialist will reach out to you shortly.",
              confirmButtonText: 'Close',
            });
          });
        });
      },
    },
  ];

  return (
    <>
      <BaseTable
        title=" "
        columns={columns}
        data={state.claims || []}
        loading={state.claims == null}
        selectableRows={false}
        rowActions={rowActions}
        noData={<NoData isPossibleAddClaim={isPossibleAddClaim} />}
      />

      {selectedClaim !== null && <EditModal claim={selectedClaim} onCloseClick={() => setSelectedClaim(null)} />}
    </>
  );
}

Table.propTypes = {
  isPossibleAddClaim: PropTypes.bool,
};

Table.defaultProps = {
  isPossibleAddClaim: false,
};
